
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '../../../controlador';
    import pregunta from './barra-preguntas-listado-pregunta.vue';
    import contestar from './barra-preguntas-listado-contestar.vue';
    import { Pregunta } from '@/__env/lib/MercadoLibre/Preguntas';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            pregunta,
            contestar,
        }
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorInterfaz;
        public get Pedido() { return this.Controlador.Pedido; }
        public get SubModo() { return this.Controlador.Vista.BarraDerecha.SubModo; }
        public set SubModo( x: string ) { this.Controlador.Vista.BarraDerecha.SubModo = x; }
        public get Modo() { return this.Controlador.Vista.BarraDerecha.Modo; }
        public set Modo( x: string ) { this.Controlador.Vista.BarraDerecha.Modo = x; }
        public get ReservarEspacioDerecha() { return this.Controlador.Vista.BarraDerecha.Anchura.Espacio; }



        public PreguntaSeleccionada: Pregunta = null;

        public SoloPendientes: boolean = false;
        @Watch( 'SoloPendientes' )
        onSoloPendientes()
        {
            this.Iniciar();
        }

        public Cargando: boolean = false;
        public Preguntas: Pregunta[] = [];

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }
        mounted()
        {
            this.Eventos.push( this.Controlador.Vista.BarraDerecha.onSubModo.subscribe( () =>
            {
                if ( this.SubModo == 'preguntas' )
                {
                    this.PreguntaSeleccionada = null;
                    //this.Controlador.Vista.BarraDerecha.Anchura.Espacio = 600;
                }
            } ) );

            this.SubModo = 'preguntas';
            this.Iniciar();
        }

        async Iniciar()
        {
            this.Cargando = true;
            this.Preguntas.clear();
            let e = await this.Pedido.CargarPreguntas();
            if ( e.hasRows() )
                this.Preguntas = e;
            this.Cargando = false;
        }

        Cerrar()
        {
            this.PreguntaSeleccionada = null;
            this.Modo = '';
        }

        public Refresh: boolean = false;
        Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }
    }
